import { useTranslation } from 'react-i18next';
import { PassFailResult } from '@/apolloClient.types';
import DurationField from '@/components/fields/DurationField';
import RadioField from '@/components/fields/RadioField';

const March20kmInnerForm = () => {
    const { t } = useTranslation('performanceResult');

    return (
        <>
            <div className="sm:col-span-2">
                <DurationField
                    name="timingSec"
                    units={['hours', 'minutes']}
                    label={t('march20km.form.timingSec')}
                    target="seconds"
                />
            </div>
            <div className="sm:col-span-2">
                <RadioField
                    variant="modern"
                    name="result"
                    label={t('march20km.form.result')}
                    options={[
                        { value: PassFailResult.Pass, label: t('march20km.form.resultPass') },
                        { value: PassFailResult.Fail, label: t('march20km.form.resultFail') },
                        { value: '', label: t('march20km.form.resultNA') },
                    ]}
                />
            </div>
        </>
    );
};

export default March20kmInnerForm;
